import {
  Box,
  Button,
  Card,
  FormControl,
  Paragraph,
  Textarea,
} from '@deckee/deck-hand';

import React, { ChangeEvent, FC, FormEventHandler, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { callEndpoint } from '../../../../../services/backend';
import { selectCurrentMember } from '../../../../../services/store/modules/backend-service';
import BasicDrawerLayout from '../../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import LogoSpinner from '../../../../shared/_deprecated/components/LogoSpinner/LogoSpinner';

const SupportRequestPage: FC = () => {
  const history = useHistory();
  const { email: emailAddress } = useSelector(selectCurrentMember);

  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitComplete, setSubmitComplete] = useState(false);
  const [feedback, setFeedback] = useState('');
  const formValid = feedback !== '' && feedback.length > 2;

  const submitFeedbackForm: FormEventHandler<HTMLFormElement> = async (
    event,
  ) => {
    event.preventDefault();
    setSubmitting(true);

    try {
      await callEndpoint(callEndpoint.endpoints.submitSupportRequest, {
        requestType: 'feedback',
        emailAddress,
        supportDescription: feedback,
      });

      setSubmitting(false);
      setSubmitComplete(true);
    } catch (e: any) {
      setError(e.message);
    }
  };

  return (
    <BasicDrawerLayout
      onBack={!submitComplete ? () => history.goBack() : undefined}
      heading="Message support"
      showMenuBar={false}
      showMapOverlay
    >
      <Card bg="transparent">
        <Card.Body>
          {!error && submitting && !submitComplete && (
            <div>
              <LogoSpinner />
            </div>
          )}

          {!error && !submitting && submitComplete && (
            <Box>
              <Box mb="3" fontWeight="bold">
                Your message has been sent!
              </Box>
              <Paragraph>
                A member of the DECKEE team will respond to you shortly at{' '}
                <strong>{emailAddress}</strong>.
              </Paragraph>
            </Box>
          )}

          {!error && !submitting && !submitComplete && (
            <form onSubmit={submitFeedbackForm}>
              {!submitComplete && (
                <FormControl label="How can we help?" name="feedback">
                  <Textarea
                    rows={8}
                    value={feedback}
                    onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
                      setFeedback(e.target?.value)
                    }
                  />
                </FormControl>
              )}

              {!submitComplete && (
                <Button.Group wide>
                  <Button type="submit" disabled={!formValid}>
                    Send
                  </Button>
                </Button.Group>
              )}
            </form>
          )}
        </Card.Body>
      </Card>
    </BasicDrawerLayout>
  );
};

export default SupportRequestPage;
